export default __webpack_public_path__ + "static/media/dog-yellow.0269cfa6.svg";